import {
    Button,
    Checkbox,
    Col,
    Form,
    Grid,
    Input,
    Modal,
    Row,
    Upload,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import PhotoButton from "../../../qforms/standard_elements/PhotoButton";
import TextArea from "antd/es/input/TextArea";
import log from "cslog";
import {
    useCreateItem,
    useUpdateItem,
} from "../../../_actions/mutations/items";
import { nanoid } from "nanoid";
import snakeCase from "lodash/snakeCase";

const { useBreakpoint } = Grid;

function AddBrandOrganization({
    show,
    setShow,
    current_user,
    initialValues = {},
}) {
    const [form] = Form.useForm();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const mutationCreate = useCreateItem("qdb_organization", () =>
        setShow(false)
    );
    const mutationUpdate = useUpdateItem(
        "qdb_organization",
        initialValues?.id,
        () => setShow(false)
    );
    const [logo_hori, setLogoHori] = useState(false);

    const closeModal = () => {
        // form.resetFields();
        setShow(false);
    };

    const is_update = !!initialValues?.id;

    const addOrganization = (values) => {
        log.d(values, "Person values");
        const new_data = {
            ...values,
            id: `${snakeCase(values.name)}_${nanoid(5)}`,
            owner: current_user?.id,
            users: [{ directus_users_id: current_user?.id }],
            is_personal: false,
        };
        log.d(new_data, "New data");
        // return;
        if (!!initialValues?.id) {
            log.p("Updating organization");
            mutationUpdate.mutate(new_data);
        } else {
            log.p("Creating organization");
            mutationCreate.mutate(new_data);
        }
    };

    log.d(initialValues, "Initial Values");

    return (
        <Fragment>
            <Modal
                title={`${is_update ? "Update" : "Add new"} organization`}
                open={show}
                width={isMobile ? "100%" : 520}
                style={
                    isMobile
                        ? { top: 0, margin: 0, maxWidth: "100vw", padding: 0 }
                        : {}
                }
                styles={{
                    body: { padding: isMobile ? "16px" : "24px" },
                    content: isMobile ? { borderRadius: 0 } : {},
                }}
                onOk={() => {}}
                confirmLoading={false}
                onCancel={closeModal}
                footer={[
                    <Button
                        key="cancel"
                        size={isMobile ? "large" : "middle"}
                        onClick={closeModal}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        size={isMobile ? "large" : "middle"}
                        onClick={() => form.submit()}
                        loading={
                            mutationCreate.isLoading || mutationUpdate.isLoading
                        }
                    >
                        {is_update ? "Update" : "Create"}
                    </Button>,
                ]}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={addOrganization}
                    // initialValues={initialValues}
                    initialValues={{
                        ...initialValues,
                        ...(logo_hori && { logo_horizontal: logo_hori }),
                    }}
                >
                    <Form.Item label="Organization Name" name="name">
                        <Input size={isMobile ? "large" : "middle"} />
                    </Form.Item>

                    <Form.Item
                        label="Organization Description"
                        name="description"
                    >
                        <TextArea
                            rows={4}
                            size={isMobile ? "large" : "middle"}
                        />
                    </Form.Item>
                    <Form.Item label="Tagline" name="tagline">
                        <Input size={isMobile ? "large" : "middle"} />
                    </Form.Item>
                    <Row gutter={[10, isMobile ? 0 : 10]}>
                        <Col xs={24} sm={8}>
                            <Form.Item label="Logo Square" name="logo">
                                <PhotoButton
                                    field={{
                                        collection: "qdb_person",
                                        field: "photo",
                                    }}
                                    width="100px"
                                    height="100px"
                                    objectFit="contain"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={16}>
                            <Form.Item
                                label="Logo Horizontal"
                                name="logo_horizontal"
                            >
                                <PhotoButton
                                    field={{
                                        collection: "qdb_person",
                                        field: "logo_hori",
                                    }}
                                    height="100px"
                                    width="auto"
                                    objectFit="contain"
                                />
                            </Form.Item>
                            <Checkbox
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        log.d(
                                            form.getFieldValue("logo"),
                                            "settintg logo_horizontal to"
                                        );
                                        form.setFieldsValue({
                                            logo_horizontal:
                                                form.getFieldValue("logo"),
                                        });
                                    } else {
                                        if (
                                            form.getFieldValue(
                                                "logo_horizontal"
                                            ) === form.getFieldValue("logo")
                                        ) {
                                            form.setFieldsValue({
                                                logo_horizontal: null,
                                            });
                                        }
                                    }
                                    log.d(
                                        form.getFieldsValue(),
                                        "form values now"
                                    );
                                }}
                            >
                                Use same as square logo
                            </Checkbox>
                        </Col>
                    </Row>

                    <Row gutter={[10, isMobile ? 0 : 10]}>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                label="Primary Phone"
                                name="primary_phone"
                            >
                                <Input size={isMobile ? "large" : "middle"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                label="Primary Email"
                                name="primary_email"
                            >
                                <Input size={isMobile ? "large" : "middle"} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Address" name="address">
                        <TextArea
                            rows={3}
                            size={isMobile ? "large" : "middle"}
                        />
                    </Form.Item>
                    <Form.Item label="Website" name="website">
                        <Input size={isMobile ? "large" : "middle"} />
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>
    );
}

export default AddBrandOrganization;
